// path: src/components/QueryCard.js
// author: Zakary Gaillard-D.
// date: 2025-10-08
// purpose: Responsive card container for the mapping form

import React from 'react';
import { Card, CardContent } from '@mui/material';

// Layout
export default function QueryCard({ children, sx, contentSx, ...cardProps }) {
    return (
        <Card
            sx={{
                // Sizing & centering
                width: {
                    xs: '100%',
                    sm: '95%',
                    md: '90%',
                    lg: '80%',
                    xl: '70%'
                },
                mx: 'auto',
                my: { xs: 1.5, sm: 2, md: 3 },
                // Visuals
                borderRadius: { xs: 0, sm: 1.5, md: 2 },
                boxShadow: { xs: 0, sm: 1, md: 3, lg: 4 },
                overflow: 'hidden',
                ...sx
            }}
            elevation={cardProps.elevation ?? 3}
            {...cardProps}
        >
            <CardContent
                sx={{
                    p: { xs: 2, sm: 2.5, md: 3, lg: 3.5, xl: 4 },
                    ...contentSx
                }}
            >
                {children}
            </CardContent>
        </Card>
    );
}
